export default __webpack_public_path__ + "static/media/brand-15.db83e7a3.png";